(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["top-stock-order"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.topStockOrderLoaded) return;
    window.topStockOrderLoaded = true;
    const handled = new WeakMap();
    const parser = new DOMParser();
    const cards = (grid) => Array.from(grid.children).filter(node => node.matches('li[data-product-id]'));
    const available = (card) => card.querySelector('product-card')?.dataset.topAvailable === 'true';

    async function arrange(grid) {
      const address = window.location.href;
      const signature = grid.dataset.topStockSignature + ':' + grid.dataset.topStockPage + ':' + address;
      if (handled.get(grid) === signature) return;
      handled.set(grid, signature);
      const sectionId = grid.closest('results-list')?.getAttribute('section-id');
      const currentPage = Number(grid.dataset.topStockPage);
      const pageSize = Number(grid.dataset.topStockSize);
      const pages = Number(grid.dataset.lastPage);
      if (!sectionId || !pageSize || !pages) return;
      const original = cards(grid);
      const byPage = new Map([[currentPage, original]]);
      const pending = Array.from({ length: pages }, (_, i) => i + 1).filter(p => p !== currentPage);
      grid.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        const worker = async () => {
          while (pending.length) {
            const page = pending.shift();
            const url = new URL(address);
            url.searchParams.set('page', String(page));
            url.searchParams.set('section_id', sectionId);
            const response = await fetch(url, { signal: controller.signal });
            if (!response.ok) throw new Error('Collection page could not be loaded');
            const doc = parser.parseFromString(await response.text(), 'text/html');
            const result = doc.querySelector('[data-top-stock-grid]');
            if (!result || Number(result.dataset.topStockPage) !== page) throw new Error('Invalid collection page');
            byPage.set(page, cards(result));
          }
        };
        await Promise.all([worker(), worker()]);
        if (!grid.isConnected || window.location.href !== address || handled.get(grid) !== signature) return;
        const all = Array.from({ length: pages }, (_, i) => byPage.get(i + 1)).flat();
        const ids = new Set(all.map(card => card.dataset.productId));
        if (ids.size !== all.length) throw new Error('Collection changed during loading');
        const ordered = all.filter(available).concat(all.filter(card => !available(card)));
        const visible = ordered.slice((currentPage - 1) * pageSize, currentPage * pageSize);
        if (!visible.length && original.length) throw new Error('Empty collection page');
        const fragment = document.createDocumentFragment();
        visible.forEach(source => {
          const card = source.cloneNode(true);
          card.dataset.page = String(currentPage);
          fragment.append(card);
        });
        original.forEach(card => card.remove());
        grid.append(fragment);
        grid.dataset.topStockSorted = "true";
        grid.dataset.topStockAvailableCount = String(all.filter(available).length);
      } catch (error) {
        controller.abort();
        grid.dataset.topStockError = 'true';
      } finally {
        clearTimeout(timeout);
        if (handled.get(grid) === signature) grid.removeAttribute('aria-busy');
      }
    }

    let scheduled = false;
    const scan = () => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => {
        scheduled = false;
        document.querySelectorAll('[data-top-stock-grid]').forEach(arrange);
      });
    };
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('popstate', scan);
    scan();
  })();
  } catch(e) { console.error(e); }
})();

})();
